import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AbstractService } from "../commons/abstract.service";
import { SearchParams } from "../commons/abstract.types";
import { DashboardCrmKpis } from "../models/dashboard-crm-kpis.model";

@Injectable({ providedIn: 'root' })
export class DashboardCrmService extends AbstractService<Record<string, unknown>> {
  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/dashboard-crm';
  }

  preCreate(obj: any): void {
    delete obj?._id;
  }

  preUpdate(obj: any): void {
  }

  getDashboardCrmKpis(params?: Partial<SearchParams>): Observable<DashboardCrmKpis> {
    let baseURL = `/kpis`;

    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }

  getDashboardCustomers(params?: Partial<SearchParams>): Observable<Array<Record<string, unknown>>> {
    let baseURL = `/top-customers`;

    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }

  getDashboardUser(params?: Partial<SearchParams>): Observable<Array<Record<string, unknown>>> {
    let baseURL = `/top-users`;

    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }

  getDashboardProducts(params?: Partial<SearchParams>): Observable<Array<Record<string, string | number>>> {
    let baseURL = `/top-products`;

    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }

  /** Open deals by stage. Takes no period: an open deal is where it sits right now. */
  getOpenByStage(params?: Partial<SearchParams>): Observable<Array<Record<string, string | number>>> {
    return super.getWithParams('/open-by-stage', params ?? {});
  }

  getRevenueChart(params?: Partial<SearchParams>): Observable<Array<Record<string, string | number>>> {
    let baseURL = `/revenue-chart`;

    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }
  getRevenueByLeadSource(params?: Partial<SearchParams>): Observable<Array<Record<string, string | number>>> {
    let baseURL = `/revenue-by-leadSource`;

    if (params) {
      for (let param in params) {
        baseURL = `${baseURL}${baseURL.includes('?') ? '&' : '?'}${param}=${params[param]}`;
      }
    }

    return super.get(baseURL);
  }
}
